module.exports = __webpack_public_path__ + "images/Favicon.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/favicons/Favicon.png
// module id = 111
// module chunks = 0